import { Box, Text } from '@chakra-ui/react'

interface FilePreviewProps {
  file: File
  width?: string
  height?: string
  showFileName?: boolean
}

export default function FilePreview({
  file,
  width = '100px',
  height = '100px',
  showFileName = true,
}: FilePreviewProps) {
  return (
    <Box position="relative" width={width}>
      <Box
        width="100%"
        height={height}
        borderRadius="md"
        overflow="hidden"
        flexShrink={0}
      >
        <img
          src={URL.createObjectURL(file)}
          alt={file.name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Box>
      {showFileName && (
        <Text fontSize="xs" mt={1} noOfLines={1} maxW={width}>
          {file.name}
        </Text>
      )}
    </Box>
  )
}
